import { InteractiveArticlePostInput } from '../../templates/inputs/InteractiveArticlePostInput';
import { ArticlePage } from '../components/ArticlePage';
import { isArticlePost } from '../PostTypes';
import { ArticlePostData } from '../types/ArticlePostType';
import { defineTemplate } from './TemplateUtils';

export type InteractiveArticlePostData = Omit<ArticlePostData, 'pages'> & {
    pages: ArticlePage[];
};

export const isInteractiveArticlePost = (
    data: unknown,
): data is InteractiveArticlePostData => {
    return (
        isArticlePost(data) && data.pages.length >= 2 && data.pages.length <= 10
    );
};

export const InteractiveArticleMedium = defineTemplate(
    'Article',
    'Medium',
    InteractiveArticlePostInput,
    () =>
        ({
            $type: 'Article',
            size: 'Medium',
            pages: [{}, {}],
        }) satisfies InteractiveArticlePostData,
    isInteractiveArticlePost,
);
export const InteractiveArticleLarge = defineTemplate(
    'Article',
    'Large',
    InteractiveArticlePostInput,
    () =>
        ({
            $type: 'Article',
            size: 'Large',
            pages: [{}, {}],
        }) satisfies InteractiveArticlePostData,
    isInteractiveArticlePost,
);
